import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setSurveyName } from '../../../actions/turnkeyOmnibusActions';

const validate = a => {
  const re = /^[a-zA-Z0-9 ]*$/;
  return re.test(a);
};

const SurveyNameForm = ({ surveyName, setSurveyName }) => {
  const initialState = {
    value: surveyName,
    hasError: !validate(surveyName),
  };

  const [state, setState] = useState(initialState);

  const _handleOnChange = e => {
    const val = e.target.value;
    const isValid = validate(val);
    setState({
      ...state,
      hasError: !isValid,
      value: val,
    });
  };

  const _updateSurveyName = () => {
    setSurveyName(state.value.trim());
  };

  const _clearSurveyName = () => {
    setState({
      ...state,
      value: '',
      hasError: false,
    });
    setSurveyName('');
  };

  return (
    <form
      className="ie--form ie--survey-name-form"
      onSubmit={e => e.preventDefault()}
    >
      <label className="ie--form--label" htmlFor="surveyName">
        Survey Name:
      </label>
      <div className="ie--form--group">
        <input
          className={`ie--form--input ${
            state.hasError ? 'ie--form--input--error' : ' '
          }`}
          type="text"
          id="surveyName"
          name="surveyName"
          value={state.value}
          onChange={_handleOnChange}
          onBlur={_updateSurveyName}
          placeholder="Enter Survey Name..."
          autoComplete="off"
        />
        <button
          type="button"
          onClick={_clearSurveyName}
          className="ie--form--input-clear"
          title="Clear"
        >
          <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
        {state.hasError && (
          <div className="ie--form--error">
            Error: Special Characters (@, /, {"'"}, ? etc) are not allowed.
          </div>
        )}
      </div>
    </form>
  );
};

SurveyNameForm.propTypes = {
  surveyName: PropTypes.string,
  setSurveyName: PropTypes.func.isRequired,
};

SurveyNameForm.defaultProps = {
  surveyName: '',
};

function mapStateToProps(state) {
  return {
    surveyName: state.turnkeyOmnibus.surveyInfo.surveyName,
  };
}

export default connect(
  mapStateToProps,
  { setSurveyName }
)(SurveyNameForm);
